module.exports = __webpack_public_path__ + "static/media/cacMuffins.7d5fc127.jpg";